import { useState, useEffect } from "react";
import "./bookings.css";
import { BookingDataTable } from "../default/variables/columnsData";
// import tableDataComplex from "../default/variables/tableDataComplex.json";
import ComplexTable from "views/admin/default/components/ComplexTable";
// import { getAllUserList } from "proxyUrl";
import { GetBookingDataByUserId } from "proxyUrl";
import { Link } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
const Bookings = () => {
  const [user, setUser] = useState("");

 const CurrentUserId = useSelector(state => state.user.user);
  
  useEffect(() => {
    fetchData();
    // if (CurrentUserId) {
    //   setLogged_user(CurrentUserId.userRole.name);
    //   setUserItem(CurrentUserId.userInfo.id)

    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
  await  axios
      .post(
        GetBookingDataByUserId,
        {
          id: CurrentUserId.userInfo.id,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        console.log(res);
        return res;
      })
      .then((userdata) => {
        const userData = userdata.data;
        setUser(userData);
      });
  };
  return (
    <>
     
      <div className=" add-booking-header  relative  mt-6 flex justify-between rounded-2xl mx-4 bg-primaryBlue p-3 shadow-lg dark:bg-navy-800">
       
        <div className="text-xl font-bold text-white  dark:text-white">
          All Bookings
        </div>
        <Link to={`/admin/bookings/add`}>
          <button className="rounded-full bg-white text-navy-800  p-1 px-3 dark:bg-navy-900 dark:text-white">
            Add Booking
          </button>
        </Link>
      </div>
      <div className="-mt-7 relative  grid w-full grid-cols-1 gap-5 md:grid-cols-1">
        {/* <TotalSpent /> */}
        {/* <WeeklyRevenue /> */}
        {user ? (
          <ComplexTable
            columnsData={BookingDataTable}
            columnLenghth={user.length}
            editRoute={`/admin/bookings/edit`}
            deleteRoute={`/admin/bookings/delete`}
            tableData={user}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default Bookings;
